import Marquee from "react-fast-marquee";
import { PARTNER_LOGOS } from "../lib/content";

export default function PartnersMarquee() {
  return (
    <section
      className="py-24 sm:py-28 bg-white border-y border-[#E3E6EC]"
      data-testid="partners-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 mb-14 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-7">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-10 h-px bg-[#F37021]" />
            <span className="text-eyebrow text-[#F37021]">Global Partners</span>
          </div>
          <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl leading-[1.02] text-[#0A1F3F]">
            Trusted partners
            <br />
            around the world.
          </h2>
        </div>
        <div className="md:col-span-4 md:col-start-9">
          <p className="text-base sm:text-lg text-[#4B5668] leading-relaxed">
            BNM Group collaborates with trusted international partners including
            manufacturers, logistics providers, and global suppliers.
          </p>
        </div>
      </div>

      <Marquee speed={45} gradient gradientColor="#FFFFFF" gradientWidth={140}>
        {PARTNER_LOGOS.map((name, i) => (
          <div
            key={i}
            className="mx-12 font-display font-black text-3xl sm:text-4xl tracking-tighter text-[#0A1F3F]/60 hover:text-[#0A1F3F] transition-colors"
          >
            {name}
          </div>
        ))}
      </Marquee>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 mt-14">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-px bg-[#E3E6EC] border border-[#E3E6EC]">
          {PARTNER_LOGOS.map((name, i) => (
            <div
              key={i}
              className="aspect-[5/2] bg-white flex items-center justify-center p-4"
              data-testid={`partner-logo-${i}`}
            >
              <span className="font-display font-black tracking-tighter text-xl sm:text-2xl text-[#0A1F3F]/70">
                {name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
